import { useRef } from "react";

export const useNav = (navLinkId) => {
	const ref = useRef(null);
	return ref;
};
